import axios from "axios";

export const getUser = async id => {
  const response = await axios.get(`/api/users/${id}`);
  return response.data;
};

export const createUser = async user => {
  const response = await axios.post(`/api/users`, { user });
  return response.data;
};

export const updateUser = async user => {
  const response = await axios.put(`/api/users`, { user });
  return response.data;
};

export const addUserToTenant = async user => {
  const response = await axios.post(`/api/user-tenant/add`, { user });
  return response.data;
};

export const deleteUserFromTenant = async id => {
  const response = await axios.delete(`/api/user-tenant/${id}`);
  return response.data;
};

export const getUsersForTenant = async (role, id) => {
  const response = await axios.get(`/api/users-for-tenant/${id}/${role}`);
  return response.data;
};

export const getTenantsForUser = async () => {
  const response = await axios.get(`/api/tenants-for-user`);
  return response.data;
};

export const deleteUser = async id => {
  const response = await axios.delete(`/api/users/${id}`);
  return response.data;
};
